  import { NgModule } from '@angular/core';
import { AuthModule } from '@spartacus/core';
import {
  BannerModule,
  CmsParagraphModule,
  LinkModule,
  PageTitleModule,
  SiteContextSelectorModule,
} from '@spartacus/storefront';
import { CustomFeatureModule } from './custom-feature/custom-feature.module';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';
import { KbFooterNavigationModule } from './custom-feature/common/components/kb-footer-navigation/kb-footer-navigation.module';
import { KbNavigationUiModule } from './custom-feature/common/components/kb-navigation-ui/kb-navigation-ui.module';

@NgModule({
  declarations: [],
  imports: [
    AuthModule.forRoot(),
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    PageTitleModule,
    SmartEditFeatureModule,
    CustomFeatureModule,
    KbNavigationUiModule,
    KbFooterNavigationModule
  
  ],
})
export class SpartacusFeaturesModule { }
